// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-card[data-v-154fcddf] .v-ripple__container{z-index:3!important}.list-card__modal__content[data-v-154fcddf]{padding-top:min(50%,40vh)}.list-card__modal__content__header[data-v-154fcddf]{max-width:70%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
